import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@envs/environment';
import {
    CambiarContrasenaRecuperacionRequest,
    CambiarContrasenaSesionRequest,
    ResponseRecuperacionUsuario,
    SolicitarRecuperacionUsuarioRequest,
    ValidarRecuperacionUsuarioRequest,
    ValidarRecuperacionUsuarioResponse
} from '@features/authentication/models/recuperacion-usuario.interface';
import { Observable } from 'rxjs';

/**
 * Cliente HTTP de recuperacion de usuario. Los tres endpoints son publicos
 * (sin Bearer); el interceptor de auth debe omitirlos.
 * Usa CW_AUTH porque GestionUsuariosRest vive en el WAR servicioAuth-rest.
 */
@Injectable({
    providedIn: 'root'
})
export class RecuperacionUsuarioService {

    private readonly _httpClient = inject(HttpClient);
    private static readonly BASE_URL = environment.API_URL
        .concat(environment.CW_AUTH)
        .concat('/apimediador/siafpplus/servicioGestionUsuarios');

    public static readonly SOLICITAR_URL = `${RecuperacionUsuarioService.BASE_URL}/solicitarRecuperacionUsuario/v1`;
    public static readonly VALIDAR_URL = `${RecuperacionUsuarioService.BASE_URL}/validarRecuperacionUsuario/v1`;
    public static readonly CAMBIAR_URL = `${RecuperacionUsuarioService.BASE_URL}/cambiarContrasenaRecuperacion/v1`;
    public static readonly CAMBIAR_SESION_URL = `${RecuperacionUsuarioService.BASE_URL}/cambiarContrasenaSesion/v1`;

    public static esUrlPublica(url: string): boolean {
        return url === RecuperacionUsuarioService.SOLICITAR_URL
            || url === RecuperacionUsuarioService.VALIDAR_URL
            || url === RecuperacionUsuarioService.CAMBIAR_URL;
    }

    solicitar(request: SolicitarRecuperacionUsuarioRequest): Observable<ResponseRecuperacionUsuario> {
        return this._httpClient.post<ResponseRecuperacionUsuario>(
            RecuperacionUsuarioService.SOLICITAR_URL,
            request
        );
    }

    validar(request: ValidarRecuperacionUsuarioRequest): Observable<ValidarRecuperacionUsuarioResponse> {
        return this._httpClient.post<ValidarRecuperacionUsuarioResponse>(
            RecuperacionUsuarioService.VALIDAR_URL,
            request
        );
    }

    cambiarContrasena(request: CambiarContrasenaRecuperacionRequest): Observable<ResponseRecuperacionUsuario> {
        return this._httpClient.post<ResponseRecuperacionUsuario>(
            RecuperacionUsuarioService.CAMBIAR_URL,
            request
        );
    }

    cambiarContrasenaSesion(request: CambiarContrasenaSesionRequest): Observable<ResponseRecuperacionUsuario> {
        return this._httpClient.post<ResponseRecuperacionUsuario>(
            RecuperacionUsuarioService.CAMBIAR_SESION_URL,
            request
        );
    }
}
